/* eslint-disable no-useless-escape */
/* eslint-disable func-names */
/* eslint-disable no-extend-native */
/* eslint-disable no-param-reassign */
const Latinise = {};
Latinise.latin_map = {
  Å: 'A', å: 'a', Æ: 'AE', æ: 'ae', Ø: 'O', ø: 'o',
};
String.prototype.latinise = function () { return this.replace(/[^A-Za-z0-9\[\] ]/g, (a) => Latinise.latin_map[a] || a); };
String.prototype.latinize = String.prototype.latinise;
String.prototype.isLatin = function () { return this === this.latinise(); };

function handleize(str) {
  str = str.toLowerCase().latinise();

  const toReplace = ['"', "'", '\\', '(', ')', '[', ']'];

  // For the old browsers
  for (let i = 0; i < toReplace.length; ++i) {
    str = str.replace(toReplace[i], '');
  }

  str = str.replace(/\W+/g, '-');

  if (str.charAt(str.length - 1) === '-') {
    str = str.replace(/-+\z/, '');
  }

  if (str.charAt(0) === '-') {
    str = str.replace(/\A-+/, '');
  }

  return str;
}

export default handleize;
